import { MethodsType, GetSchema } from '@/define';
import { Helper } from '@/methods/base';
import { createMethodRenderer } from '@/methods/renderer';
import Store, { ErrorType } from '@/store';

export class PostHelper extends Helper {
  // 待处理的数据
  constructor(uri: string, method: MethodsType, params: GetSchema) {
    super(uri, method, params);
  }
  // post/put/delete 有 data 参数
  generatorDefineData() {
    const key = this.renderGetMethodDefineData();
    if (!key) {
      return {
        key: '',
        propertiesKey: {},
        definitionsKey: {},
      };
    }
    const bodySchema = this.sourceSchema.parameters.find((item) => item.in === 'body');
    if (!bodySchema) {
      return {
        key: '',
        propertiesKey: {},
        definitionsKey: {},
      };
    }

    // 边界情况1：bodySchema 没有 schema 定义
    if (!bodySchema.schema) {
      Store.pushError({
        url: this.uri,
        method: this.method,
        errorType: ErrorType.SchemaError,
        desc: this.description,
        errMsg: '缺少 body schema 定义',
      });
      
      const defaultAnyInfo = {
        key,
        propertiesKey: {
          $ref: `#/definitions/${key}`,
        },
        definitionsKey: {
          title: key,
          type: 'object',
          additionalProperties: true,
          description: this.description,
        },
      };
      this.getApiInteraces.push(defaultAnyInfo);
      return {
        key: '',
        propertiesKey: {},
        definitionsKey: {},
      };
    }

    // 边界情况2：schema 只有 type，没有 properties（object 类型）
    const schema = bodySchema.schema as any;
    const hasProperties = schema.properties || (schema.items && schema.items.properties);
    if (schema.type === 'object' && !hasProperties) {
      Store.pushError({
        url: this.uri,
        method: this.method,
        errorType: ErrorType.SchemaError,
        desc: this.description,
        errMsg: 'body schema 缺少 properties 定义',
      });
      
      const defaultAnyInfo = {
        key,
        propertiesKey: {
          $ref: `#/definitions/${key}`,
        },
        definitionsKey: {
          title: key,
          type: 'object',
          additionalProperties: true,
          description: this.description,
        },
      };
      this.getApiInteraces.push(defaultAnyInfo);
      return {
        key: '',
        propertiesKey: {},
        definitionsKey: {},
      };
    }

    // 正常处理流程
    try {
      // 先把根节点的response设置好
      if (bodySchema.schema?.type !== 'array') {
        this.setTypeObjToInstances(key, '', bodySchema.schema);
      }
      // 编辑response对象
      this.generatorDeepDefine(key, '', bodySchema.schema);
    } catch (err) {
      // 如果处理过程中出错，生成 any 类型定义
      Store.pushError({
        url: this.uri,
        method: this.method,
        errorType: ErrorType.SchemaError,
        desc: this.description,
        errMsg: `body schema 处理失败: ${(err as Error).message}`,
      });
      
      const defaultAnyInfo = {
        key,
        propertiesKey: {
          $ref: `#/definitions/${key}`,
        },
        definitionsKey: {
          title: key,
          type: 'object',
          additionalProperties: true,
          description: this.description,
        },
      };
      this.getApiInteraces.push(defaultAnyInfo);
    }

    // post的情况会在处理response的时候顺带处理
    return {
      key: '',
      propertiesKey: {},
      definitionsKey: {},
    };
  }
}

export const usePostMethdos = (uri: string, method: MethodsType, params: GetSchema) => {
  // POST/PUT/DELETE 请求包含 data 参数
  return createMethodRenderer(uri, method, params, true);
};
